import { ChatService } from './chat.service';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppAvailability } from '@ionic-native/app-availability';
import { EmailComposer } from '@ionic-native/email-composer';
import { FileOpener } from '@ionic-native/file-opener';
import { ModalController, Platform } from 'ionic-angular';
import { API } from './api';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { HTTP } from '@ionic-native/http';
import { File, FileEntry } from '@ionic-native/file';
import { GalleryModal } from 'ionic-gallery-modal';
import { Firebase } from '@ionic-native/firebase';
import { TranslateService } from '@ngx-translate/core';
import { MessagePresenter } from './message.service';

declare let cordova: any;
@Injectable()
export class Utils {

  lineHeight: number = 16;
  go:any;

  constructor(private readonly domSanitizer: DomSanitizer,
              private readonly api: API,
              private readonly screenOrientation: ScreenOrientation,
              private readonly platform: Platform,
              private readonly inapp: InAppBrowser,
              private readonly fileOpener: FileOpener,
              private readonly file: File,
              private readonly emailComposer: EmailComposer,
              private readonly appAvailability: AppAvailability,
              private readonly http2: HTTP,
              private readonly firebase: Firebase,
              private readonly messagePresenter: MessagePresenter,
              private readonly translate: TranslateService,
              private readonly modalCtrl: ModalController,
              public chatService: ChatService
    ) { }

  liveResizeTexArea(area: string, lines: number) {
    // get elements
    const element = document.getElementById(area);
    const textarea = element.getElementsByTagName('textarea')[0];

    // set default style for textarea
    textarea.style.minHeight = '0';
    textarea.style.height = '0';
    const limitSize = this.lineHeight * lines;
    // limit size to 96 pixels (6 lines of text)
    let scrollHeight = textarea.scrollHeight;
    if (scrollHeight > limitSize) {
      scrollHeight = limitSize;
    }

    // apply new style
    element.style.height = scrollHeight + 'px';
    textarea.style.minHeight = scrollHeight + 'px';
    textarea.style.height = scrollHeight + 'px';
  }

  urlify(text) {
    const urlRegex = /((http(s)?(\:\/\/))+(www\.)?([\w\-\.\/])*(\.[a-zA-Z]{2,3}\/?))[^\s\b\n|]*[^.,;:\?\!\@\^\$ -]/g;
    return text.replace(urlRegex, (url) => {
      if (!text.toString().includes('href')) {
        return `<a href="${url}">${url}</a>`;
      } else {
        return url;
      }
    });
  }

  hasUrlYoutube(text) {
    console.log('dentro de hasUrlYoutube',text);
    

    const urlRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
    return urlRegex.test(text);
  }

  getYoutubeIdFromUrl(url: string) : string { 
    console.log('url',url);
   
    let i = !!url?.includes('youtube.com');
    console.log('soy i',i);
    console.log(typeof i);
    
      if(i){
       const urlRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((?:\w|-){11})(?:&list=(\S+))?$/;
       return url.split(urlRegex)[1];
      }else{
       return undefined;
      }
    return undefined;
    
  }

  getYoutubeUrlEmbedFromUrl(url:string,body) : SafeResourceUrl {  

    const id = this.getYoutubeIdFromUrl(url);  
    console.log('id');
    
    if(id != undefined){
      return this.domSanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${id}`);
    }else{
      let video = body.split('src');
      if(!!video[0].includes('https://www.youtube.com/watch?v=')){
        let newLink = video[0].split('https://www.youtube.com/watch?v=')[1];       
        return this.domSanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${newLink}`);
      }else{
        console.log('estoy en el else');
        
        if(!!video[0].includes('https://www.youtu.be/')){
          console.log('dentro del if de video');
          
        let newLink = video[0].split('https://www.youtu.be/')[1];
        return this.domSanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${newLink}`);
      }else{
        let newData: string;
        if(video[1] == undefined){
          console.log('holap');          
        }else{
           newData = video[1].split('?feature')[0].split('www.youtube.com/embed/')[1];
        }       
        if (newData != undefined){
         return this.domSanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${newData}`);
        }else{
          console.log('en el else');
          
          return undefined;
        }
      }
      }
      
     
    }
  }

  replaceAccents(str) : string {
    // verifies if the String has accents and replace them
    let strAux = str;
    if (strAux.search(/[\xC0-\xFF]/g) > -1) {
      strAux = strAux
        .replace(/[\xC0-\xC5]/g, 'A')
        .replace(/[\xC6]/g, 'AE')
        .replace(/[\xC7]/g, 'C')
        .replace(/[\xC8-\xCB]/g, 'E')
        .replace(/[\xCC-\xCF]/g, 'I')
        .replace(/[\xD0]/g, 'D')
        .replace(/[\xD1]/g, 'N')
        .replace(/[\xD2-\xD6\xD8]/g, 'O')
        .replace(/[\xD9-\xDC]/g, 'U')
        .replace(/[\xDD]/g, 'Y')
        .replace(/[\xDE]/g, 'P')
        .replace(/[\xE0-\xE5]/g, 'a')
        .replace(/[\xE6]/g, 'ae')
        .replace(/[\xE7]/g, 'c')
        .replace(/[\xE8-\xEB]/g, 'e')
        .replace(/[\xEC-\xEF]/g, 'i')
        .replace(/[\xF1]/g, 'n')
        .replace(/[\xF2-\xF6\xF8]/g, 'o')
        .replace(/[\xF9-\xFC]/g, 'u')
        .replace(/[\xFE]/g, 'p')
        .replace(/[\xFD\xFF]/g, 'y');
    }
    return strAux;
  }

  getThumbOfVideo() {
    let video;
    let results;

    const getThumb = function (url, size) {
      if (url === null) {
        return '';
      }
      const sizeAux = (size === null) ? 'big' : size;
      results = url.match('[\\?&]v=([^&#]*)');
      video = (results === null) ? url : results[1];

      let numUrl = '0';
      if (sizeAux === 'small') {
        numUrl = '2';
      }
      return `http://img.youtube.com/vi/${video}/${numUrl}.jpg`;
    };

    return {
      thumb: getThumb,
    };
  }


  public openFile(url: string, file: any, title: string, loading: boolean) { // TODO: revisar
    console.log('openFile');
    
    if (url.includes('.pdf')) {
      this.messagePresenter.presentLoadingCustom('crescent', this.translate.instant('loadScroll'), null);
      this.openFile2(url, true).then(result => {
        this.messagePresenter.dismissLoadingCustom();
      }).catch(error => {
        this.messagePresenter.dismissLoadingCustom();
      });
    } else if (url.includes('.jpeg')) {
      const photos = [{
        url,
        type: 'jpeg',
      }];
      const modal = this.modalCtrl.create(GalleryModal, { photos, initialSlide: 0, closeIcon: 'close' });
      modal.present();
      modal.onDidDismiss(data => {
        this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
      });
    } else {
      this.openLink(url);
    }
  }

  private downloadFile(url: string, name: string): Promise<any> {
    return this.http2.downloadFile(url, {}, {}, cordova.file.dataDirectory + name).then(result => {
      return result;
    }).catch(error => {
      return Promise.reject(error); // TODO: revisar
    });
  }

  private openFile2(url: string, update: boolean) { // TODO: revisar naming...
    const auxFileName = decodeURI(url).split('/');
    const fileName = auxFileName[auxFileName.length - 1];
    if (!update) {
      return this.file.checkFile(cordova.file.dataDirectory, fileName).then(exist => {
        return this.localFile(cordova.file.dataDirectory, fileName);
      }).catch(error => {
        return this.externalFile(url, fileName);
      });
    } return this.externalFile(url, fileName);
  }

  private externalFile(url: string, name: string): Promise<any> {
    return this.downloadFile((this.platform.is('ios')) ? encodeURI(url) : decodeURI(url), name).then((result) => {
      const auxFileName = result.nativeURL.split('/');
      const fileName = auxFileName[auxFileName.length - 1];
      const pathName = result.nativeURL.split(fileName)[0];

      return this.localFile(pathName, fileName);
    }).catch(error => {
      return error;
    });
  }

  private localFile(url: string, fileName: string) {
    this.file.resolveLocalFilesystemUrl(decodeURI(url + fileName)).then(directoryEntry => {
      const fileEntry = directoryEntry as FileEntry;

      fileEntry.file(success => {
        this.fileOpener.open(decodeURI(url + fileName), success.type)
          .then(() => console.log(''))
          .catch(e => console.log(''));

      },             () => { });
    },
    ).catch(err => { console.error(''); });
  }

  public openLink(link) {
    let newLink = '';
    if(!!link.includes('https://www.youtube.com/watch?v=')){
         newLink = link.split('https://www.youtube.com/watch?v=')[1];
        newLink = `https://www.youtube.com/embed/${newLink}`;
      }else if(!!link.includes('https://www.youtu.be/')){
        newLink = link.split('https://www.youtu.be/')[1];
       newLink = `https://www.youtube.com/embed/${newLink}`;
       console.log('newLink',newLink);
     }
     console.log('newLink',newLink);
     
    const options: InAppBrowserOptions = {
      location: 'no',
      hardwareback: 'yes',
    }
      let inAppBrowserRef =this.inapp.create(newLink != '' ? newLink : link, '_blank', options);  
  }

  pruebas(){
    console.log('dentro de pruebas');
    
  }

  public checkAndOpenIfMailAppAvailable(email) {
    const mailto = `mailto:${email}`;
    if (!this.getIsApp()) {
      this.inapp.create(mailto, '_system');
    } else {
      if (this.platform.is('ios')) {
        this.appAvailability.check('googlegmail:///').then(
          (yes: boolean) => this.sendEmailComposer(email, 'gmail'),
          (no: boolean) => location.href = mailto,
        );
      } else {
        this.sendEmailComposer(email);
      }
    }
  }

  private sendEmailComposer(email, app?) {
    const opts = {
      to: email,
      subject: '',
      isHtml: false,
    };

    if (app) {
      opts['app'] = app;
    }
    this.emailComposer.open(opts);
  }

  public getIsApp() {
    //console.log('ES APP antiguo' + !document.URL.startsWith('http') || document.URL.startsWith('http://localhost:8080'));
    // return (!document.URL.startsWith('http') || document.URL.startsWith('http://localhost:8080'));
    
    if (document.URL.startsWith(this.api.baseWebUrl) || document.URL.includes(this.api.baseWebLocal)) {
      //console.log('NO ES APP');
      return false;
    } else {
      //console.log('SI ES APP');
      return true;
    }
  }

  public openLogoutPopup() {
    const popUp = this.modalCtrl.create('PopUpLogout');
    popUp.present();
    popUp.onDidDismiss((data) => {
      if (data) {
         this.chatService.logoutSubscriptions(); // TODO: revisar si falla en teams sin chat.
        if (this.getIsApp()) {
          this.firebase.getToken().then(token => {
            console.log(token);
            console.log('token');

            
            if (token == null) {  
              this.api.clearLocalStorageAndGoLogin();
              return;
            }
            this.api.logoutDevice({ token }).then(response => {
              this.api.clearLocalStorageAndGoLogin();
            }).catch(error => {
              this.api.clearLocalStorageAndGoLogin();
            });
          });
        } else {
          this.api.clearLocalStorageAndGoLogin();
        }
        this.go='go';
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/Utils.ts